import {
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faAt,
  faBackspace,
  faBan,
  faBell,
  faCertificate,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleNotch,
  faCog,
  faCreditCard,
  faDollarSign,
  faDownload,
  faEnvelope,
  faExchangeAlt,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkSquareAlt,
  faEye,
  faEyeSlash,
  faImage,
  faInfinity,
  faInfoCircle,
  faKey,
  faKeyboard,
  faLink,
  faSync,
  faCopy,
  faListAlt,
  faPen,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faPrint,
  faQrcode,
  faSearch,
  faShareAlt,
  faShoppingCart,
  faSignature,
  faSpinner,
  faTimesCircle,
  faTrash,
  faUserCircle,
  faWallet,
  faSort,
} from '@fortawesome/free-solid-svg-icons';

import {
  faCircle as faRegularCircle,
  faClipboard as faRegularClipboard,
  faCopy as faRegularCopy,
  faSquare as faRegularSquare,
} from '@fortawesome/free-regular-svg-icons';

import { faBitcoin } from '@fortawesome/free-brands-svg-icons';

const icons = {
  faEye,
  faEyeSlash,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faBackspace,
  faCog,
  faBell,
  faCircle,
  faRegularClipboard,
  faShoppingCart,
  faTimesCircle,
  faInfoCircle,
  faBan,
  faChevronUp,
  faChevronDown,
  faChevronRight,
  faUserCircle,
  faKeyboard,
  faCheckCircle,
  faRegularCircle,
  faSpinner,
  faExclamationCircle,
  faSearch,
  faPlusSquare,
  faTrash,
  faWallet,
  faPlusCircle,
  faExclamationTriangle,
  faLink,
  faSync,
  faCopy,
  faAt,
  faCheckSquare,
  faRegularSquare,
  faCheck,
  faSignature,
  faPen,
  faEnvelope,
  faRegularCopy,
  faImage,
  faExchangeAlt,
  faDownload,
  faShareAlt,
  faQrcode,
  faKey,
  faDollarSign,
  faExternalLinkSquareAlt,
  faInfinity,
  faCreditCard,
  faBitcoin,
  faListAlt,
  faCertificate,
  faExclamation,
  faPlus,
  faPrint,
  faCircleNotch,
  faSort,
};

export default icons;
